import { useMemo } from "react";
import useSWR from "swr";
import { useHprService } from "../../context/HprServiceContext";
import { IPerson } from "../../models/IPerson";
import { HprCacheKeys } from "../cacheKeys";
import { useHprSettings } from "../hprSettings/useHprSettings";

export type IUsePersonHook = (personId: IPerson["id"] | null) => {
    data: IPerson | null;
    fetching: boolean;
};

export const usePerson: IUsePersonHook = (personId) => {

    const { data: settings } = useHprSettings();
    const certList = settings?.certs ? Object.keys(settings?.certs) : [];

    const service = useHprService();

    const fetcher = async (): Promise<IPerson | null> => {
        if (!personId) return null;
        const personData = await service.getPerson(personId, certList);
        if (personData.isFailure) {
            throw personData.error;
        }

        return personData.value;
    };

    const { data, isValidating } = useSWR(() =>
        HprCacheKeys.PersonInstance(personId || 0),
        fetcher,
        {
            suspense: true,
            revalidateOnFocus: false,
            revalidateOnMount: false,
            refreshWhenHidden: false
        }
    );

    const rawData = data || null;

    return useMemo(() => ({
        data: rawData,
        fetching: isValidating,
    }), [rawData, isValidating]);

};